import axios from "axios";
import { BaseUrl } from "../../Actions/Base";

const axiosInstance = axios.create({
  baseURL: BaseUrl,
  withCredentials: true,
});
// export const getAllCompleteEvents = async () => {
//   try {
//     const res = await axiosInstance.get("/api/completed-classes");
//     return res;
//   } catch (error) {
//     return error;
//   }
// };
export const getAllCompleteEvents = async (instituteId) => {
  try {
    const res = await axiosInstance.get("/api/completed-classes", {
      params: {
        instituteId: instituteId
      }
    });
    return res;
  } catch (error) {
    return error;
  }
};

export const getSingleLearnerAllCompleteEvents = async (EnrollmentId) => {
  try {
    const res = await axiosInstance.get("/api/single-learner-completed-classes", {
      params: {
        EnrollmentId: EnrollmentId
      }
    });
    return res;
  } catch (error) {
    return error;
  }
};

export const getInstructorAllCompleteEvents = async (InstructorId) => {
  try {
    const res = await axiosInstance.get("/api/single-instructor-completed-classes", {
      params: {
        InstructorId: InstructorId
      }
    });
    return res;
  } catch (error) {
    return error;
  }
};

export const getCompletedLocation = async (key) => {
  try {
    const res = await axiosInstance.post(`/api/track-location`, { key });
    return res.data;
  } catch (error) {
    return error;
  }
};
